import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import type { Vehicle } from '../../../types/vehicle';
import { formatKm, formatPrice } from '../../../utils/vehicles';
function Flag({
  value
}: {
  value: boolean;
}) {
  return value ? <span className="inline-flex items-center gap-1.5 font-semibold text-emerald-300" data-id="element-422" data-mp="5dpd12rxhq3t">
      <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-423" data-mp="aaxzvgo0uibe" />
      Sí
    </span> : <span className="inline-flex items-center gap-1.5 text-mist" data-id="element-424" data-mp="38uxtpjax6jwy">
      <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-425" data-mp="3dspw5796xofe" />
      No
    </span>;
}
export function ComparisonTable({
  vehicles
}: {
  vehicles: Vehicle[];
}) {
  const rows: {
    label: string;
    render: (v: Vehicle) => React.ReactNode;
  }[] = [{
    label: 'Precio',
    render: v => <span className="font-bold text-white" data-id="element-426" data-mp="2q3es9gwjndx1">
          {formatPrice(v.precio, v.moneda)}
        </span>
  }, {
    label: 'Año',
    render: v => v.anio
  }, {
    label: 'Kilometraje',
    render: v => formatKm(v.kilometraje)
  }, {
    label: 'Transmisión',
    render: v => v.transmision
  }, {
    label: 'Combustible',
    render: v => v.combustible
  }, {
    label: 'Financiación',
    render: v => <Flag value={v.financiacion} data-id="element-427" data-mp="32w0fd0nfoi7v" />
  }, {
    label: 'Acepta permuta',
    render: v => <Flag value={v.permuta} data-id="element-428" data-mp="2y14h3irlsymb" />
  }, {
    label: 'Estado',
    render: () => 'Usado seleccionado'
  }, {
    label: 'Disponibilidad',
    render: v => v.disponible ? 'Disponible' : 'Reservado'
  }];
  return <div className="mt-6 overflow-x-auto rounded-2xl border border-line vc-scroll" data-id="element-429" data-mp="2k3670pkbfocm">
      <table className="w-full min-w-[560px] border-collapse text-left text-sm" data-id="element-430" data-mp="2k597y4n0b1w4">
        <caption className="sr-only" data-id="element-431" data-mp="2f4lelcbb28yq">
          Comparativa de precio, año, kilometraje y condiciones de las unidades
          seleccionadas
        </caption>
        <thead data-id="element-432" data-mp="dcyn79ni4c1q">
          <tr className="bg-surface2/70" data-id="element-433" data-mp="dbngp22o8q6x">
            <th scope="col" className="w-40 px-4 py-3.5 text-[12px] font-semibold uppercase tracking-wide text-mist" data-id="element-434" data-mp="dach7eg9e4lm">
              Comparativa
            </th>
            {vehicles.map(v => <th key={v.id} scope="col" className="px-4 py-3.5 text-[13px] font-bold text-white" data-id="element-435" data-mp="22s0xzgu2rrh8">
                {v.marca} {v.modelo}
                <span className="block text-[12px] font-medium text-mist" data-id="element-436" data-mp="1sttiz3jcjjhv">
                  {v.version}
                </span>
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-437" data-mp="2li8w1kix3rqk">
          {rows.map((row, i) => <tr key={row.label} className={i % 2 === 0 ? 'bg-surface2/25' : 'bg-transparent'} data-id="element-438" data-mp="2qjojfj8kiac4" data-mpi={i}>
              <th scope="row" className="px-4 py-3 text-[12.5px] font-semibold uppercase tracking-wide text-mist" data-id="element-439" data-mp="2cjds6f3citqf">
                {row.label}
              </th>
              {vehicles.map(v => <td key={v.id} className="px-4 py-3 text-[13.5px] text-white/90" data-id="element-440" data-mp="156lf8q1kgihy">
                  {row.render(v)}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}